import React, { useEffect, useState } from 'react';
import { View, ScrollView, Image } from 'react-native';
import { Card, Paragraph, RadioButton } from 'react-native-paper';
import { useDispatch, useSelector } from 'react-redux';

import AsyncStorage from '@react-native-async-storage/async-storage';
import styles from './styles';
import { AppHeader } from '../../../components/common';
import { getAvailablePlans } from '../../../redux/actions/workerActions';
import { AppButton, AppText } from '../../../components/form';
import { UserActions } from '../../../redux/reducers/userReducer';
import PriceBlock from '../../../components/common/PriceBlock';
import { appColors } from '../../../assets/styles/global';

export default function PlansPersonal({ navigation }) {
  const [isEmployee, setIsEmployee] = useState(true);
  const [group, setGroup] = useState(1);
  useEffect(() => {
    AsyncStorage.getItem('PROFILE').then((result) => {
      if (result !== null) {
        return setIsEmployee(true);
      }
      return setIsEmployee(false);
    });
  }, []);

  const { userSignUp } = useSelector((state) => state.user);
  const { availablePlans } = useSelector((state) => state.worker);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAvailablePlans());
  }, []);
  const handleSchedule = (id_plano, isGroup) => {
    dispatch({ type: UserActions.UPDATE_SIGNUP, userSignUp: { ...userSignUp, id_plano, group_qnt: isGroup ? group : '1' } });
    navigation.navigate('Profile Trainer', { screen: 'Cadastro Personal Trainer' });
  };

  return (
    <>
      <AppHeader navigation={navigation} hasBack={!isEmployee} title="Planos Personal Trainer" />
      <View style={styles.viewBase}>
        <ScrollView style={styles.baseScroll}>
          <Card style={styles.baseCard}>
            <View style={styles.viewTitleDescription}>
              <AppText size="bold" style={styles.titleDescription}>Detalhes:</AppText>
            </View>
            <Card.Content style={styles.cardContentDescription}>
              <AppText style={styles.textDescription}>
                Você poderá contratar um Personal Trainer com sua conta Pessoal
              </AppText>
              <AppText style={styles.textDescription}>
                Reúna amigos e contrate o Personal Trainer em grupo com até 4 participantes.
              </AppText>
              <AppText style={styles.textDescription} size="bold">
                OU
              </AppText>
              <AppText style={styles.textDescription}>
                Tenha um Personal Trainer exclusivo no plano individual.
              </AppText>
            </Card.Content>

          </Card>
          {
            !!availablePlans?.length && availablePlans.map((plan) => {
              const group_qnt = [];
              if (plan.qtd_colaboradores > 1) {
                for (let i = 2; i <= plan.qtd_colaboradores; i++) {
                  group_qnt.push(i);
                // more statements
                }
              }
              return (
                <Card style={styles.baseCard} key={`plan-card-${plan.id_plano}`}>
                  {plan.imagem && (
                  <Image
                    source={plan.imagem}
                    style={styles.imagePlan}
                  />
                  )}
                  <Card.Content style={styles.cardContent}>
                    <View style={styles.cardTitle}>
                      <PriceBlock price={plan.valor} perHour />
                    </View>
                    <View style={styles.cardBody}>
                      <AppText style={styles.cardTitleText}>{plan.plano}</AppText>
                      <Paragraph style={styles.cardTitleText}>{plan.descricao}</Paragraph>
                      {plan.qtd_colaboradores > 1 ? (
                        <>
                          <AppText>Alunos no grupo:</AppText>

                          <RadioButton.Group onValueChange={(newValue) => setGroup(newValue)} value={group}>
                            <View style={{ flexDirection: 'row' }}>
                              {group_qnt.map((value) => (
                                <View key={value} style={{ alignItems: 'center' }}>
                                  <AppText>{value}</AppText>
                                  <RadioButton color={appColors.primary} value={value} />
                                </View>
                              ))}

                            </View>

                          </RadioButton.Group>
                        </>
                      ) : console.log()}
                    </View>
                  </Card.Content>
                  <AppButton label="AGENDAR" labelStyle={styles.textButton} style={styles.cardButton} disabled={plan.qtd_colaboradores > 1 && group === 1} onPress={() => handleSchedule(plan.id_plano, plan.qtd_colaboradores > 1)} />
                  {/* <AppButton labelStyle={styles.textButtonSchedule} label="Agendar" style={styles.buttonSchedule} onPress={() => handleSchedule(plan.id_plano)} /> */}

                </Card>

              );
            })

          }
        </ScrollView>
      </View>
    </>
  );
}
